// Centralised content for Carbon on Country

export const IMAGES = {
  hero: "https://images.pexels.com/photos/32915384/pexels-photo-32915384.jpeg",
  opportunity: "https://images.unsplash.com/photo-1611564393101-b834b74a9b48",
  fire: "https://images.pexels.com/photos/33632881/pexels-photo-33632881.jpeg",
  monitoring: "https://customer-assets.emergentagent.com/job_nature-capability/artifacts/g3qf6yoo_daintree%20panoramic%20-%20right%20yes.jpeg",
  workforce: "https://images.pexels.com/photos/32915492/pexels-photo-32915492.jpeg",
  regrowth: "https://images.unsplash.com/photo-1776319190799-06b12a8103cd",
  outback1: "https://images.unsplash.com/photo-1529108190281-9a4f620bc2d8",
  bushland: "https://images.unsplash.com/photo-1500382017468-9049fed747ef",
  data: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
};

export const AUDIENCES = [
  "For Ranger Programs",
  "For Traditional Owners",
  "For Indigenous Corporations",
  "For Environmental Workforce Development",
];

export const OPPORTUNITY_LIST = [
  "Monitor environmental outcomes",
  "Collect and manage data",
  "Assess biodiversity",
  "Verify carbon claims",
  "Conduct field inspections",
  "Use GIS and remote sensing technology",
  "Prepare reports and compliance documentation",
  "Manage environmental projects",
];

export const RANGER_CAPABILITIES = [
  "Monitor Country",
  "Collect ecological data",
  "Undertake biodiversity surveys",
  "Manage fire",
  "Use GPS and mapping tools",
  "Conduct compliance activities",
  "Maintain long-term environmental records",
  "Work with Traditional Owners and cultural knowledge holders",
];

export const LEADERSHIP_LIST = [
  "Design projects",
  "Manage projects",
  "Monitor projects",
  "Verify outcomes",
  "Conduct audits",
  "Manage environmental data",
  "Support decision making",
];

export const PATHWAYS = [
  {
    slug: "carbon-auditor",
    number: "01",
    title: "Carbon Auditor",
    summary:
      "Understand how carbon projects are designed, monitored, reported and verified.",
    skills: [
      "ACCU Scheme fundamentals",
      "Carbon methodologies",
      "Monitoring and reporting",
      "Compliance requirements",
      "Audit preparation",
      "Risk assessment",
      "Carbon project verification",
    ],
    careers: [
      "Carbon Auditor",
      "Carbon Compliance Officer",
      "Carbon Project Officer",
    ],
    image: "https://images.pexels.com/photos/32915384/pexels-photo-32915384.jpeg",
  },
  {
    slug: "nature-repair-auditor",
    number: "02",
    title: "Nature Repair Auditor",
    summary:
      "Support the delivery and verification of biodiversity and restoration outcomes.",
    skills: [
      "Nature Repair Market fundamentals",
      "Biodiversity assessment",
      "Restoration monitoring",
      "Outcome verification",
      "Project reporting",
      "Field auditing",
    ],
    careers: [
      "Nature Repair Auditor",
      "Restoration Monitoring Officer",
      "Biodiversity Verification Officer",
    ],
    image: "https://images.unsplash.com/photo-1776319190799-06b12a8103cd",
  },
  {
    slug: "biodiversity-assessor",
    number: "03",
    title: "Biodiversity Assessor",
    summary:
      "Build capability in ecological monitoring and environmental assessment.",
    skills: [
      "Species monitoring",
      "Habitat assessment",
      "Vegetation condition assessment",
      "Survey design",
      "Data collection",
      "Ecological reporting",
    ],
    careers: [
      "Biodiversity Assessor",
      "Environmental Monitoring Officer",
      "Ecological Field Officer",
    ],
    image: "https://customer-assets.emergentagent.com/job_nature-capability/artifacts/g3qf6yoo_daintree%20panoramic%20-%20right%20yes.jpeg",
  },
  {
    slug: "natural-capital-monitor",
    number: "04",
    title: "Natural Capital Monitor",
    summary:
      "Learn how environmental assets are measured, valued and reported.",
    skills: [
      "Natural capital frameworks",
      "Environmental accounting",
      "Monitoring systems",
      "Data management",
      "Reporting and metrics",
    ],
    careers: [
      "Natural Capital Monitor",
      "Environmental Data Officer",
      "Sustainability Reporting Officer",
    ],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
  },
  {
    slug: "carbon-project-manager",
    number: "05",
    title: "Carbon Project Manager",
    summary:
      "Develop the skills required to plan and manage environmental projects.",
    skills: [
      "Project planning",
      "Stakeholder engagement",
      "Governance",
      "Budgets and reporting",
      "Procurement",
      "Monitoring frameworks",
      "Risk management",
    ],
    careers: [
      "Carbon Project Manager",
      "Environmental Program Coordinator",
      "Natural Resource Management Officer",
    ],
    image: "https://images.pexels.com/photos/32915492/pexels-photo-32915492.jpeg",
  },
  {
    slug: "native-seed-collection",
    number: "06",
    title: "Seed Collection Training",
    summary:
      "Practical training in native seed collection, provenance, storage and restoration readiness — delivered on Country.",
    skills: [
      "Understanding native seed systems",
      "Seed collection planning",
      "Provenance and genetics",
      "Field seed collection techniques",
      "Seed handling and storage",
      "Data collection and monitoring",
      "Restoration readiness",
    ],
    careers: [
      "Native Seed Collector",
      "Seed Bank Coordinator",
      "Restoration Technician",
      "Restoration Supervisor",
    ],
    image:
      "https://images.unsplash.com/photo-1776319190799-06b12a8103cd",
    detailHref: "/pathways/native-seed-collection",
  },
];

export const LEARNING_ACTIVITIES = [
  "Field-based workshops",
  "Ranger-led monitoring activities",
  "GIS and mapping exercises",
  "Biodiversity surveys",
  "Carbon project site visits",
  "Cultural governance discussions",
  "Project planning exercises",
];

export const SERVICES = [
  {
    slug: "ranger-workforce-development",
    number: "01",
    title: "Ranger Workforce Development",
    summary:
      "Supporting ranger programs to identify future environmental workforce opportunities.",
    items: [
      "Workforce planning",
      "Skills assessments",
      "Capability gap analysis",
      "Training pathway design",
      "Partnership development",
    ],
  },
  {
    slug: "carbon-project-readiness",
    number: "02",
    title: "Carbon Project Readiness",
    summary:
      "Helping organisations understand what is required before entering carbon markets.",
    items: [
      "Carbon opportunity assessments",
      "Governance readiness",
      "Project feasibility support",
      "Monitoring framework development",
      "Data management planning",
    ],
  },
  {
    slug: "nature-repair-readiness",
    number: "03",
    title: "Nature Repair Readiness",
    summary:
      "Supporting participation in biodiversity and restoration markets.",
    items: [
      "Restoration planning",
      "Monitoring frameworks",
      "Biodiversity assessment systems",
      "Data and reporting systems",
    ],
  },
  {
    slug: "environmental-monitoring-systems",
    number: "04",
    title: "Environmental Monitoring Systems",
    summary:
      "Developing practical systems for environmental data collection and reporting.",
    items: [
      "Monitoring protocols",
      "Mobile data collection systems",
      "GIS integration",
      "Environmental reporting frameworks",
    ],
  },
  {
    slug: "seed-collection-training",
    number: "05",
    title: "Seed Collection Training",
    summary:
      "On-Country training in native seed collection, provenance, storage and restoration planning for ranger programs and Aboriginal corporations.",
    items: [
      "Seed systems & demand context",
      "Collection planning & cultural protocols",
      "Provenance and genetics",
      "Field techniques and storage",
      "Data, monitoring and restoration readiness",
    ],
    linkHref: "/pathways/native-seed-collection",
    linkLabel: "View full training",
  },
];

export const FUTURE_ROLES = [
  "Carbon Auditors",
  "Nature Repair Auditors",
  "Biodiversity Assessors",
  "Natural Capital Monitors",
  "Carbon Project Managers",
  "Environmental Data Officers",
  "GIS Specialists",
  "Drone Operators",
  "Restoration Supervisors",
  "Seed Collection Coordinators",
  "Native Seed Enterprise Managers",
  "Ecological Monitoring Officers",
];

// Slug-keyed resource library — matches backend RESOURCE_LIBRARY in /app/backend/server.py
export const RESOURCES = [
  {
    slug: "carbon-farming",
    title: "Carbon Farming",
    subtitle:
      "An introduction for ranger programs and Traditional Owner organisations.",
    excerpt:
      "Carbon farming combines fire management, vegetation restoration, soil practice and avoided clearing to store carbon and reduce emissions on Country.",
    topics: ["Methods overview", "ACCU eligibility", "Ranger alignment", "Getting started"],
  },
  {
    slug: "carbon-markets",
    title: "Carbon Markets",
    subtitle: "How environmental outcomes are turned into tradeable units.",
    excerpt:
      "Compliance and voluntary markets are reshaping how environmental work is funded — but every credit still relies on people on the ground.",
    topics: ["Compliance vs voluntary", "Pricing", "Integrity & co-benefits", "Workforce link"],
  },
  {
    slug: "accu-projects",
    title: "ACCU Projects",
    subtitle: "Designing, registering and running carbon projects in Australia.",
    excerpt:
      "From methodology selection to ACCU issuance — a plain-language overview of the project lifecycle and where ranger programs fit.",
    topics: ["The ACCU Scheme", "Project lifecycle", "Pitfalls", "Hosting projects"],
  },
  {
    slug: "nature-repair",
    title: "Nature Repair",
    subtitle:
      "The Nature Repair Market and what it means for Indigenous land management.",
    excerpt:
      "Australia's biodiversity certificate market is designed to recognise Indigenous land management — and to stack with carbon income.",
    topics: ["What it is", "Stacking with carbon", "Methodologies", "Indigenous opportunities"],
  },
  {
    slug: "biodiversity-monitoring",
    title: "Biodiversity Monitoring",
    subtitle: "Practical methods for measuring biodiversity on Country.",
    excerpt:
      "Plot surveys, camera traps, acoustic monitoring, eDNA and remote sensing — and how ranger-led monitoring sets the standard.",
    topics: ["Why monitor", "Common methods", "Designing programs", "Ranger-led"],
  },
  {
    slug: "environmental-reporting",
    title: "Environmental Reporting",
    subtitle: "From field data to verified outcomes.",
    excerpt:
      "Reports must serve regulators, investors and the people who hold Country. Each audience has different evidence needs.",
    topics: ["Audiences", "Principles", "Cycles", "Plain language"],
  },
  {
    slug: "gis-and-mapping",
    title: "GIS and Mapping",
    subtitle: "Tools that turn observation into evidence.",
    excerpt:
      "Open and proprietary GIS tools, mobile data collection, and the role of cultural data governance in mapping decisions.",
    topics: ["QGIS & ArcGIS", "Mobile apps", "Cultural data", "Sovereignty"],
  },
  {
    slug: "environmental-data-systems",
    title: "Environmental Data Systems",
    subtitle:
      "Designing the data infrastructure that supports projects over decades.",
    excerpt:
      "Carbon projects must remain auditable for 25–100 years. Designing for that horizon changes every technical decision.",
    topics: ["Why systems matter", "Principles", "Components", "CARE + FAIR"],
  },
  {
    slug: "indigenous-participation-frameworks",
    title: "Indigenous Participation Frameworks",
    subtitle:
      "From consultation to leadership — frameworks that work.",
    excerpt:
      "The most durable frameworks operate at the partnership and leadership levels — and they centre Free, Prior and Informed Consent.",
    topics: ["Levels of participation", "FPIC", "Co-benefits", "Relationships"],
  },
  {
    slug: "carbon-project-governance",
    title: "Carbon Project Governance",
    subtitle: "Structures that protect Country and the project over time.",
    excerpt:
      "Carbon projects run for decades. Governance must outlive the individuals who set it up — and centre cultural authority.",
    topics: ["Why governance", "Key roles", "Decision-making", "Common structures"],
  },
];

export const RANGER_SUPPORT = [
  "Workforce planning",
  "Project readiness",
  "Monitoring systems",
  "Environmental reporting",
  "Career pathway development",
];

// Placeholder case studies — content can be edited by the team
export const CASE_STUDIES = [
  {
    slug: "north-kimberley-fire-and-carbon",
    title: "Building carbon literacy with a North Kimberley ranger program",
    partner: "Wunggurr Rangers (placeholder)",
    country: "North Kimberley, Western Australia",
    year: "2025",
    summary:
      "We worked with a North Kimberley ranger program to translate their long-standing cool-burn fire management into the documentation, monitoring and audit-ready evidence required for ACCU savanna fire methodology.",
    outcomes: [
      "Carbon opportunity assessment delivered",
      "Three rangers trained as field data leads",
      "Monitoring protocol mapped to ACCU methodology",
      "Pathway to Carbon Auditor qualification documented",
    ],
    image:
      "https://images.pexels.com/photos/33632881/pexels-photo-33632881.jpeg",
    quote:
      "We have always managed fire. Now we have the evidence to tell that story to the carbon market.",
    attribution: "Ranger Coordinator (placeholder attribution)",
  },
  {
    slug: "central-desert-nature-repair-readiness",
    title: "Nature Repair readiness with a Central Desert Aboriginal corporation",
    partner: "Tjuwanpa Land Management (placeholder)",
    country: "Central Desert, Northern Territory",
    year: "2025",
    summary:
      "Co-designed a biodiversity monitoring system that integrates fauna camera networks, ranger field surveys and a cultural data governance layer — readying the organisation to register a Nature Repair Market project.",
    outcomes: [
      "Monitoring framework signed off by Traditional Owners",
      "Camera trap network across 12 sites",
      "Indigenous Data Sovereignty governance documented",
      "Biodiversity baseline report delivered",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_nature-capability/artifacts/g3qf6yoo_daintree%20panoramic%20-%20right%20yes.jpeg",
    quote:
      "The system was built for Country first, then for the market — that order matters.",
    attribution: "CEO (placeholder attribution)",
  },
  {
    slug: "cape-york-workforce-pathway",
    title: "Workforce pathway design across a Cape York ranger network",
    partner: "Apunipima Ranger Network (placeholder)",
    country: "Cape York, Queensland",
    year: "2026",
    summary:
      "Designed a five-year workforce pathway that maps existing ranger capability against emerging environmental professions — Carbon Auditor, Biodiversity Assessor, Natural Capital Monitor and Carbon Project Manager.",
    outcomes: [
      "Skills assessments for 22 rangers",
      "Capability gap analysis across four programs",
      "Training pathway design with two TAFE partners",
      "Pipeline of three internal carbon project leads",
    ],
    image:
      "https://images.pexels.com/photos/32915492/pexels-photo-32915492.jpeg",
    quote:
      "We were already doing the work. Now our people have the qualifications to lead it.",
    attribution: "Workforce Lead (placeholder attribution)",
  },
];
